import './BodySmall02.scss';
import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  as?: React.ElementType;
  children: React.ReactNode;
};

export const BodySmall02 = ({ className, as: Cmp = 'p', children }: Props): React.ReactElement => (
  <Cmp className={clsx('bp-body-small-02', className)}>
    {children}
  </Cmp>
);
